import { render, staticRenderFns } from "./LoginDealStatement.vue?vue&type=template&id=a8c3ea48&scoped=true&"
import script from "./LoginDealStatement.vue?vue&type=script&lang=js&"
export * from "./LoginDealStatement.vue?vue&type=script&lang=js&"
import style0 from "./LoginDealStatement.vue?vue&type=style&index=0&id=a8c3ea48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c3ea48",
  null
  
)

export default component.exports